module.exports = __webpack_public_path__ + "static/Burst_2s-1419dfcde11aa95657eda4db65bba448.jpg";